import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { threadsKeys } from './threads.keys';
import { getThreads, getThreadHistory, getThreadHistoryPage } from './threads.api';
const THREAD_HISTORY_PAGE_LIMIT = 25;
export const useThreadsQuery = () => {
    return useQuery({
        queryKey: threadsKeys.all(),
        queryFn: () => getThreads(),
        staleTime: Infinity
    });
};
/** @deprecated */
export const useThreadHistoryQuery = () => {
    return useQuery({
        queryKey: threadsKeys.history(),
        queryFn: () => getThreadHistory(),
        staleTime: Infinity
    });
};
export const useThreadHistoryPageQuery = (limit = THREAD_HISTORY_PAGE_LIMIT) => {
    return useInfiniteQuery({
        staleTime: Infinity,
        queryKey: threadsKeys.historyPages(),
        queryFn: ({ pageParam }) => getThreadHistoryPage({ from: pageParam, limit }),
        initialPageParam: new Date().toISOString(),
        getNextPageParam: (lastPage) => {
            return lastPage.existsMore ? lastPage.items[lastPage.items.length - 1]?.timestamp : undefined;
        },
        select: (data) => {
            return data.pages.flatMap((page) => page.items);
        }
    });
};
//# sourceMappingURL=threads.query.js.map